import { NgModule } from '@angular/core';
import { setContext } from '@apollo/client/link/context';
import { APOLLO_NAMED_OPTIONS, NamedOptions } from 'apollo-angular';
import { environment } from '../../environments/environment';
import { InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';
import { ApolloModule } from 'apollo-angular';
import { STORAGE_KEYS } from '@core/configs/app.constants';

export function createNamedApollo(httpLink: HttpLink) {
  // Authenticated notifications client (Bearer token)
  const authLink = setContext(() => {
    const token = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN) || localStorage.getItem(STORAGE_KEYS.TOKEN);
    return { headers: { Authorization: token ? `Bearer ${token}` : '' } };
  });

  // Public notifications client (x-api-key)
  const apiKeyLink = setContext(() => {
    const apiKey = environment.notificationApiKey || '';
    return { headers: { 'x-api-key': apiKey } };
  });

  return <NamedOptions>{
    ovsAppSyncAuth: {
      link: authLink.concat(httpLink.create({ uri: environment.notificationGraphqlUrl })),
      cache: new InMemoryCache()
    },
    ovsAppSyncPublic: {
      link: apiKeyLink.concat(httpLink.create({ uri: environment.notificationGraphqlUrl })),
      cache: new InMemoryCache()
    }
  };
}

@NgModule({
  imports: [
    ApolloModule
  ],
  providers: [
    {
      provide: APOLLO_NAMED_OPTIONS,
      useFactory: createNamedApollo,
      deps: [HttpLink]
    }
  ],
})
export class GraphQLModule { }
